export const DEFAULT_EMAIL_TEMPLATE = {
  id: '',
  name: '',
  html: '',
  subject: '',
  buttonLabel: '',
  type: 'collection-delivery'
};
